import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom }: Theme) => ({
  container: {
    color: custom.grey[3],
  },
  greyedText: {
    color: custom.grey[10],
  },
  brackets: {
    display: 'inline-block',
    textAlign: 'left',
    minWidth: 26,
    color: custom.grey[10],
  },
}));
